const BikashMajumder = require("./team_imgs/BikashMajumder.jpeg");
const BijonKSarker = require("./team_imgs/BijonKSarker.jpeg");
const PriyaDas = require("./team_imgs/PriyaDas.jpeg");
const AnupMondal = require("./team_imgs/AnupMondal.jpeg");
const PabelDey = require("./team_imgs/PabelDey.jpeg");
const JoharKSarker = require("./team_imgs/JoharKSarker.jpeg");
const MolayDas = require("./team_imgs/MolayKDas.jpeg");
const BakulKBarman = require("./team_imgs/BakulCBarman.jpeg");
const KallolDas = require("./team_imgs/KollolDas.jpeg");
const PushpakDhar = require("./team_imgs/PushpakKDhar.jpeg");
const RipanSaha = require("./team_imgs/RipanSaha.jpeg");
const AlfredBhowmick = require("./team_imgs/AlfredBhowmick.jpeg");
const defaultImg = require("./team_imgs/default.png");

export const people = [
  {
    id: 0, // Used in JSX as a key
    name: "Ripan Kumar Saha",
    profession: "",
    description: `The minorities in Bangladesh are facing what can only be described as an ongoing genocide. 
    For decades, Hindus and other religious minorities have endured systematic massacres, forced conversions, 
    land grabbing, and bullying. While the oppression has been a continuous reality for over 50 years, the scale 
    and intensity of these crimes have sharply increased with targeted humiliation and carefully planned mob attacks
    in recent months following the rise of Islamic fundamentalists within the country’s power structure.
    The interim government has completely failed to protect vulnerable communities. In many regions, Hindu families 
    have had their homes burned, temples desecrated, women rapped, and businesses destroyed. Lands have been grabbed
    with impunity, and many have been forced out of their livelihoods. In some cases, Hindus were compelled to resign 
    from their jobs — and even coerced into converting to Islam simply to keep their employment.
    
    Adding to this persecution is a new wave of digital harassment and follow up injustice. Misinformation is 
    deliberately spread on social media to demean and bully Hindus. Even more troubling, Hindu social media accounts
    are often hacked to post fabricated or controversial content, after which the innocent account holders are targeted
    for punishment. The justice system, instead of serving as a safeguard, has often failed to support victims. 
    Perpetrators of these atrocities walk free, while victims are left voiceless and without protection. This cycle of 
    violence and impunity makes it clear: the plight of Bangladesh’s minorities is not just a series of isolated 
    incidents, but a systemic campaign to erase their identity, culture, and existence.
    At this juncture, we feel the need for our collaborative efforts to make Hindu voices heard for their existence and
    human rights in an independent and democratic country. We want to ensure that Hindus should not fear expressing their
    faith, that temples are places of peace, not targets of hate, and that justice is not delayed or denied. 
    The Hindu community of Bangladesh has endured far too much. It is time the world stands with them — not merely in 
    sympathy, but in concerted action.`,
    country: "USA",
    role: "Director",
    image: RipanSaha,
  },
  {
    id: 1, // Used in JSX as a key
    name: "Johar Kanti Sarker",
    profession: "Data Analyst",
    description: `We as a Hindu have to realize that nobody else but only we can decide what will be our future. Contrary to the popular belief, 
      I think we are already united but not organized yet. We are united under various small sects, groups, committees and communities. But we are not connected and nmissing the networking component. 
      We are working and living individually like isolated islands. 
      We need a collaborative platform, where all of us will work together in a discplined and organized way. We need a link which will 
      bridge the gap among us. ISRHB is established to work as the link to bridge the gap among all the individuals and organizations who are working for the betterment of Hindus in Bangladesh.
    `,
    country: "Germany",
    role: "Director",
    team: "Lead, Project and Quality management",
    image: JoharKSarker,
  },
  {
    id: 3, // Used in JSX as a key
    name: "Bikash Majumber",
    profession:
      "Human Resources Administration at the Department of Social Services",
    description: `I am Bikash Majumder - a human activist and social worker currently residing in New York. 
    I work in the Human Resources Administration at the Department of Social Services as an eligibility specialist.
    I want to work for the Hindu community of Bangladesh because of their long history of persecution.
    Hindus are deprived of social justice, religious freedom, and human rights in Bangladesh.
    They regularly face religious atrocities, targeted killings, ethnic cleansing, forced conversions, land grabbing, and sexual violence.
    Therefore, I want the world to know the fate of Bangladeshi Hindus and put an end to these heinous activities.`,
    country: "USA",
    role: "Director",
    image: BikashMajumder,
  },
  {
    id: 4, // Used in JSX as a key
    name: "Molay Kumar Dev Das ",
    profession: "",
    description: `Every human being deserves equal dignity, safety, and freedom, regardless of religion, ethnicity,
     or language.  Defending minorities is essential to stop injustices such as discrimination, forced displacement,
     and violence. Bangladesh once had a vibrant and diverse religious population, but the percentage of minorities has
    sharply declined due to systemic oppression, violence, and lack of justice. 
    I strongly believe that advocacy is essential to preserving the rights and contributions of religious minorities,
    ensuring they are not erased from the nation’s history. This is where the role of ISRHB becomes highly relevant, 
    as it is committed to addressing these issues and developing concrete, long-term policies to support religious 
    minorities in Bangladesh.`,
    country: "Bangladesh",
    role: "Director",
    image: MolayDas,
  },
  {
    id: 5, // Used in JSX as a key
    name: "Anup Kumar Mondal",
    profession: "Managing Director, Quick Route Pty Ltd",
    description: `The number of religious minorities in Bangladesh has sharply declined due to systematic oppression,
    injustice, and state-led discrimination across all areas of life. Just a few decades ago, more than 31 percent of
    the population in East Pakistan were religious minorities; today, that figure has sadly fallen to roughly eight 
    percent. Nothing has been able to stop this cleansing, and justice has never been delivered for the atrocities 
    committed against Hindus in Bangladesh. Since the independence of Bangladesh every single government helped islamic
    extremist groups to torture minorities directly or indirectly. 

    ISRHB has been actively working in key areas such as documentation, legal aid, and raising global awareness by
    bringing these real incidents to the attention of the international community. I am committed to playing a 
    significant role in connecting ISRHB with other like-minded organizations to strengthen our shared mission.`,
    country: "Australia",
    role: "Director",
    image: AnupMondal,
  },
  {
    id: 6, // Used in JSX as a key
    name: "Priya Rani Das",
    profession: "Voice Artist",
    description: `First of all, I truly feel gratitude to everyone for giving me the chance to be your team member.
    Secondly, I want to be involved with the Federation because this cause is deeply personal to me.
    My own family has been a victim of the injustice and persecution faced by the Hindu community in Bangladesh.
    We have experienced firsthand the pain of displacement, discrimination, and fear — not just as distant statistics, but as real human suffering that has shaped our lives.

    This lived experience gives me both the responsibility and the motivation to speak up and act. I no longer want to remain a silent witness to the suffering of others who are still facing the same struggles we once endured.
    By working with the Federation, I hope to:

    •⁠ - Raise awareness about the ongoing human rights violations.
    •⁠ - Support victims who are currently going through what my family went through.
    •⁠ - Advocate for justice and legal reforms to protect minorities in Bangladesh.
    •⁠ - Preserve the cultural and spiritual heritage of our community.
    •⁠ - Work toward peace, safety, and dignity for all marginalized groups.

    Involvement in this organization is not just activism for me — it’s a form of healing, resistance, and purpose.
    I want to turn our painful past into a meaningful future for others.`,
    country: "Australia",
    role: "Director",
    image: PriyaDas,
  },
  {
    id: 7, // Used in JSX as a key
    name: "Bijon Krishna Sarker",
    profession: "",
    description: `Since the Partition of India in 1947, systematic persecution of religious minorities began in East
     Pakistan. Behind this oppression stood not only Islamic extremist groups but also, to varying degrees, almost all
     mainstream democratic political parties. In 1964, the then government of East Pakistan declared Hindus as enemies
     of the state through a Military Ordinance. Research shows that under this law, a significant portion of Hindu-owned
     property and assets was seized by the state.
     Although Bangladesh was born in 1971 at the cost of three million lives—including nearly two million Hindus—the 
     Hindu community continues to be treated as second-class citizens. The country’s constitution itself reflects a 
     biased attitude toward Hindus. Political Islam has been deliberately embedded at every level of society, to the 
     point where no state institution willingly assumes its constitutional responsibility to protect Hindus. As a result,
     the legal system has effectively become two-tiered. Nearly all those arrested and prosecuted under the pretext 
     of ‘hurting religious sentiments’ have been Hindus, showing how the state has functionally become deeply religious 
     and discriminatory.
     In 1947, non-Muslims made up 31% of the population of this land; by 2025, that number has fallen to around 8%. 
     In this dire context, we have established this international organization, the Initiative for the Survival and 
     Rights of Hindus in Bangladesh (ISRHB). I am hopeful that ISRHB will make every possible effort to fulfill its
     commitments. The organization envisions a future where religious minorities in Bangladesh will finally be able to
     live peacefully under the protection of the constitution—a right earned through their blood.`,
    country: "Australia",
    role: "Secretary",
    image: BijonKSarker,
  },
  {
    id: 8, // Used in JSX as a key
    name: "Pabel Kanti Dey",
    profession: "Graduate Research Student, Chungnam National University",
    description: `As a researcher, I always focus on data that reveals the real stories. ISRHB is documenting and presenting data
    on the systematic atrocities faced by religious minorities, particularly Hindus, in Bangladesh. This is why 
    I became involved with this research-based organization, which is preserving the narratives of systemic and ongoing
    oppression through its database.`,
    country: "South Korea",
    accomplishment: "electromagnetism theory",
    role: "Member",
    image: PabelDey,
  },
  {
    id: 9, // Used in JSX as a key
    name: "Bakul Chandra Barman",
    profession: "",
    description: `As citizens of an independent country, the Hindus of Bangladesh along with other minorities were
     supposed to enjoy rights and security. Yet, even after 54 years of independence, these promises have never been
     realized. Instead, Islamic extremists have continuously carried out brutal persecution, oppression, and violence
     with the aim of eradicating minorities from the country. The government and judicial system have never taken any 
     action against these terrorists. Therefore, it is essential for all of us to come together and work collectively 
     to establish the rights and ensure the safety of minorities. It is with this hope and conviction that I became 
     associated with ISRHB. From my position, I have always stood with ISRHB and will continue to strive to fulfill my
     responsibilities.`,
    country: "Nepal",
    role: "Personal Relations Officer",
    image: BakulKBarman,
  },
  {
    id: 10, // Used in JSX as a key
    name: "Kallol Das",
    profession: "",
    description: `For decades, the Hindu community in Bangladesh has not only been constitutionally and politically deprived,
     but also systematically persecuted. Due to prolonged state oppression, meaningful internal connections within the Hindu
     community have failed to develop. When people are forced to remain constantly preoccupied with simply ensuring their survival,
     building networks among themselves becomes an immense challenge. As an internal coordinator, I am undertaking this important 
     responsibility through ISRHB. I am hopeful that, with ISRHB’s efforts, we will be able to foster unity within the Hindu community
     and awaken a sense of national identity among Bangladeshi Hindus.`,
    country: "United Kingdom",
    accomplishment: "",
    role: "Personal Relations Officer",
    image: KallolDas,
  },
  {
    id: 11, // Used in JSX as a key
    name: "Pushpak Kumar Dhar",
    profession: "",
    description: `Since my childhood, I have observed a lack of harmonious relationships within the Hindu community.
     People rarely dare to come forward in support of one another, making it extremely difficult to protect anyone 
     from the assaults of the state and communal forces. This very weakness has made Hindus vulnerable to systematic
     persecution. Therefore, communication and cooperation among individuals and organizations within the Hindu 
     community are absolutely essential. In this regard, I am deeply grateful to ISRHB for entrusting me with this
     significant responsibility.`,
    country: "South Korea",
    role: "Personal Relations Officer",
    image: PushpakDhar,
  },
  {
    id: 12, // Used in JSX as a key
    name: "Alfred Bhowmick",
    profession: "Network Engineer",
    description: `I joined the ISRHB because I believe in standing against discrimination and protecting the dignity,
    safety, and freedom of my community. This platform allows me to raise awareness, support vulnerable people, and 
    work toward a society where everyone can live with respect and equal rights. 

    I will work to raise awareness about the challenges faced by Hindus in Bangladesh, support affected individuals, 
    and advocate for their rights and security. I will also participate in campaigns, discussions, and initiatives that
    promote equality, justice, and peaceful coexistence.`,
    country: "Germany",
    role: "Treasurer",
    image: AlfredBhowmick,
  },
];
